var map = {
	"./ar.png": 807,
	"./blank-language.png": 808,
	"./en.png": 809,
	"./id.png": 810,
	"./ru.png": 811,
	"./th.png": 812,
	"./vi.png": 813,
	"./zh-cn.png": 814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;